module.exports = __webpack_public_path__ + "img/shiyanshi-22.f7132669.jpg";